<template>
  <fragment>
    <ExpansionPanelFilters class="my-4">
      <v-form
        ref="form"
        class="search-forms"
        @submit.prevent="filterCancellation"
      >
        <v-row>
          <v-col cols="12" md="3" sm="4">
            <BaseTextField
              v-model="filter.pesquisar"
              :placeholder="$t('reports.search')"
              @input="handleSearch"
              append-icon="mdi-magnify"
              single-line
              hide-details
              clearable
            ></BaseTextField>
          </v-col>

          <v-col cols="12" md="3" sm="4">
            <date-time-picker
              :label="$t('reports.initial-date')"
              @formatted-date="handleInitDateTime"
            ></date-time-picker>
          </v-col>

          <v-col cols="12" md="3" sm="4">
            <date-time-picker
              :label="$t('reports.final-date')"
              @formatted-date="handleEndDateTime"
            ></date-time-picker>
          </v-col>

          <v-col class="d-flex justify-end">
            <BaseButton
              variant="filter"
              class="button rounded-xxl"
              type="submit"
            >
              {{ $t("reports.filter") }}
            </BaseButton>
          </v-col>
        </v-row>
      </v-form>
    </ExpansionPanelFilters>

    <v-data-table
      class="rounded-lg"
      :no-data-text="$t('reports.no-info-found')"
      :loading-text="$t('reports.loading-info')"
      :headers="headers"
      :loading="cancellationLoading"
      :items="allCancellation.info"
      mobile-breakpoint="0"
      :items-per-page="10"
      :header-props="{
        class: 'rounded-t-lg',
        color: $config.dados.corinputs,
      }"
      :footer-props="{
        class: 'rounded-b-lg',
        itemsPerPageOptions: [10, 20, 50],
        itemsPerPageText: $t('reports.cancellation.cancellation-per-page'),
      }"
    >
      <template v-slot:item.valor="{ item }">
        {{ item.valor | moeda }}
      </template>
      <template v-slot:item.motivo_cancelamento="{ item }">
        {{ item.motivo_cancelamento || "-" }}
      </template>
      <template v-slot:item.dthr_cancelamento="{ item }">
        {{ item.dthr_cancelamento || "-" }}
      </template>
      <template v-slot:item.usuario_cancelamento="{ item }">
        {{ item.usuario_cancelamento || "-" }}
      </template>
    </v-data-table>
  </fragment>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import dayjs from "dayjs";
import _ from "lodash";
import DateTimePicker from "@/components/forms/DateTimePicker.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import ExpansionPanelFilters from "@/components/forms/ExpansionPanelFilters.vue";

export default {
  name: "Cancellation",
  components: {
    DateTimePicker,
    BaseTextField,
    BaseButton,
    ExpansionPanelFilters,
  },
  data() {
    return {
      filter: {
        pesquisar: "",
        initDateTime: "",
        endDateTime: "",
      },
      search: "",
      dayjs: dayjs,
    };
  },
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters([
      "storeSequencial",
      "cancellation",
      "allCancellation",
      "cancellationLoading",
      "intervalDates",
      "reportsFilter",
      "idProduto",
    ]),
    headers() {
      return [
        {
          text: this.$t("reports.order"),
          align: "start",
          value: "localizador",
          width: 120,
          sortable: false,
        },
        {
          text: this.$t("reports.cancellation.media"),
          align: "start",
          value: "midia",
          width: 120,
          sortable: false,
        },
        {
          text: this.$t("reports.cancellation.cancellation-date-time"),
          align: "start",
          value: "dthr_cancelamento",
          width: 260,
        },
        {
          text: this.$t("reports.cancellation.cancellation-user"),
          align: "start",
          value: "usuario_cancelamento",
          width: 220,
        },
        {
          text: this.$t("reports.cancellation.observation"),
          align: "start",
          value: "motivo_cancelamento",
          width: 300,
        },
        {
          text: this.$t("reports.ticket"),
          align: "start",
          value: "dsc_produto",
          width: 240,
        },
        {
          text: this.$t("reports.cancellation.buyers-name"),
          align: "start",
          value: "nome",
          width: 160,
        },
        {
          text: this.$t("reports.cancellation.buyers-document"),
          align: "start",
          value: "documento",
          width: 140,
        },
        {
          text: this.$t("reports.value"),
          align: "end",
          value: "valor",
          width: 140,
        },
      ];
    },
  },
  methods: {
    ...mapActions(["fetchCancellation"]),
    ...mapMutations(["setCancellationLoading", "setReportsFilter"]),
    filterCancellation() {
      let filter = {};

      if (this.filter.initDateTime) {
        Object.assign(filter, {
          dthr_canc_ini: this.filter.initDateTime,
        });
      }

      if (this.filter.endDateTime) {
        Object.assign(filter, {
          dthr_canc_fim: this.filter.endDateTime,
        });
      }

      Object.assign(filter, {
        producerId: this.storeSequencial,
        idproduto: this.idProduto,
        pesquisar: this.filter.pesquisar,
      });

      this.setReportsFilter(filter);
      this.fetchCancellation(filter);
    },
    handleSearch: _.debounce(function (event) {
      this.filter.pesquisar = event;
      this.filterCancellation();
    }, 500),
    handleInitDateTime(formatteddatetime) {
      this.filter.initDateTime = formatteddatetime;
    },
    handleEndDateTime(formatteddatetime) {
      this.filter.endDateTime = formatteddatetime;
    },
  },

  mounted() {
    this.filterCancellation();
  },
  destroyed() {
    this.filter = {
      pesquisar: "",
      initDateTime: "",
      endDateTime: "",
    };
  },
};
</script>

<style scoped></style>
